import React, { Component } from "react";
import $ from "jquery";
import { Grid, Col, Row, Button } from "react-bootstrap";
import "./Blog.css";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon
} from "react-share";
import ResponsiveEmbed from "react-responsive-embed";
import { LinkContainer } from "react-router-bootstrap";
import { HashLink } from "react-router-hash-link";
import EstimatorFooter from "../components/EstimatorFooter";

export default class Blog extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    /* $(".App").css("background", "rgb(255, 255, 255, 0)"); */
    $(".App").css("background", "none");
  }

  renderLoginButton() {
    if (this.props.isAuthenticated) {
      return (
        <LinkContainer to="/beta">
          <Button>LOGIN</Button>
        </LinkContainer>
      );
    } else {
      return (
        <LinkContainer to="/login">
          <Button>LOGIN</Button>
        </LinkContainer>
      );
    }
  }

  renderDemoButton() {
    if (this.props.isAuthenticated) {
      return (
        <LinkContainer to="/beta">
          <Button>DEMO</Button>
        </LinkContainer>
      );
    } else {
      return (
        <LinkContainer to="/register">
          <Button>DEMO</Button>
        </LinkContainer>
      );
    }
  }

  render() {
    const shareURL = "estimator.digimasters.co.uk";
    return (
      <Grid className="blog-container">
        <Col xs={12} md={12}>
          <Row>
            <Col xs={12} md={9}>
              <h1 className="title-text">Visual Analytics Project Estimator</h1>
            </Col>
            <Col xs={12} md={3}>
              <Row>
                <FacebookShareButton
                  url={shareURL}
                  className="socialmedia-button"
                >
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
                <TwitterShareButton
                  url={shareURL}
                  className="socialmedia-button"
                >
                  <TwitterIcon size={32} round />
                </TwitterShareButton>
                <LinkedinShareButton
                  url={shareURL}
                  className="socialmedia-button"
                >
                  <LinkedinIcon size={32} round />
                </LinkedinShareButton>
              </Row>
              <Row>{this.renderLoginButton()}</Row>
            </Col>
          </Row>
          <Row>
            {this.renderDemoButton()}
            <HashLink to="/">
              <Button>HOME</Button>
            </HashLink>
            <HashLink to="/#pricing">
              <Button>PRICING</Button>
            </HashLink>
          </Row>
          <Row>
            <ResponsiveEmbed
              src="https://www.youtube.com/embed/naDEEPchLf8"
              allowFullScreen
              id="tutorial"
            />
            <h3 id="1">Why use a top down estimator?</h3>
            <p>
              An estimator is used to quickly work out how much effort is
              required to design, build, test and deploy a piece of software.
            </p>
            <p>
              Estimates are key to working out delivery dates, size of teams and
              also budget requirements to deliver the project.
            </p>
            <p>
              Visual analytics and data visualisation are relatively new
              capabilities for many companies. Our top down estimator was
              created to help organisations estimate the effort required to
              build dashboards in some of the major visual analytics software
              provider platforms such as Qlik, Tableau, Microsoft, Looker, and
              more.
            </p>
            <p>
              We’ve developed the estimator to also take into account custom
              visualisations developed using JavaScript libraries including
              simple charts from{" "}
              <a
                href="https://www.chartjs.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="light-grey"
              >
                chart.js
              </a>{" "}
              as well as completely bespoke{" "}
              <a
                href="https://d3js.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="light-grey"
              >
                d3.js
              </a>{" "}
              development.
            </p>
            <p>
              Our demo video and examples are there to provide a clear
              understanding of what the estimator expects for a simple, medium
              or complex object, which should allow experienced developers,
              architects and new business users to get started straight away
              with only either a little bit of knowledge regarding the data
              visualisation tool. A project manager feeding in numbers provided
              by their technical lead or development team can create an initial
              estimate in under 5 minutes which is perfect for quick validation
              of estimates from an agile grooming session or investigating a
              change request from a client.
            </p>
            <h3 id="2">Who is the estimator for?</h3>
            <p>
              Our <span className="light-grey">Personal</span> tier is aimed at
              individual users who could be:
            </p>
            <ul>
              <li>
                A contractor attempting to provide a quick estimate to their
                client for a fixed price project or time and materials
              </li>
              <li>
                A project manager wanting to get an initial idea or second
                opinion
              </li>
              <li>
                An in-house developer or consultant attempting to demonstrate
                the effort required for a new project to their leadership
              </li>
            </ul>
            <p>
              The estimator is here for individuals to demonstrate to their line
              manager, project manager, or client, how they came up with their
              estimates and some of the assumptions they have made around amount
              of effort for management, business analysis, testing and knowledge
              transfer to support teams.
            </p>
            <p>
              Having an application which builds confidence and efficiency into
              data and analytics project delivery is a huge asset. Typical
              business intelligence or visual analytics projects can start
              around $20,000 and go beyond $2,000,000. For $14.99 a month or
              just $169.99 a year, you get access to our estimator which is
              continually updated and refined as technologies continue to
              develop and more features are automated.
            </p>
            <p>
              Our <span className="light-grey">Enterprise</span> tier is for
              companies continually developing analytics assets and is aimed at:
            </p>
            <ul>
              <li>All companies using visualisation tools internally</li>
              <li>
                System integrators and consulting firms building solutions for
                their clients
              </li>
              <li>
                Any company with more than 10 people creating plans or estimates
              </li>
            </ul>
            <p>
              This tier focuses on sharing and collaboration around creating the
              estimates as well as providing unlimited user accounts. We have
              also applied a further discount for annual subscriptions to our
              estimator services.
            </p>
            <h3 id="3">What are a top down estimator's limitations?</h3>
            <p>
              A top down estimator is design to give quick initial guidance and
              is not a detailed bottom up estimate of every task required to
              deliver a project.
            </p>
            <p>
              Our estimator is designed to support agile and waterfall delivery
              methods, however it is not meant to replace detailed planning
              required on large complex delivery projects.
            </p>
            <p>
              Top down estimators are excellent at speeding up the sales cycle
              for delivery teams and supporting creation of business cases and
              ROI calculations. We still recommend that any pricing created off
              the back of a top down estimate is clearly labelled as a Rough
              Order of Magnitude (ROM) and could change by up to ~20% through
              detailed planning and scoping.
            </p>
            <p>
              We have included the ability for our{" "}
              <span className="light-grey">Personal</span> and{" "}
              <span className="light-grey">Enterprise</span> customers to alter
              the effort variables we have used as a default to help refine the
              estimates even further. Our defaults are based on many successful
              deliveries and adapt to changes in the different technologies.
            </p>
            <p>
              You may have a team of extremely experienced consultants,
              developers or business self-service users, or you may have a new
              team of junior analysts or new self-service users. Our default
              values assume experienced resources (6 months to 1+ year) so
              having the ability to tweak the variables is a key feature which
              is not available in our free tier.
            </p>
            <h3 id="4">What technologies power the estimator?</h3>
            <p>
              The estimator is powered by a serverless architecture running on
              AWS. At a high level it is comprised of the following components:
            </p>
            <h3>Front-end: React, S3</h3>
            <p>
              The front-end stack of the estimator is built with{" "}
              <span className="light-grey">React</span>, using many staples of
              modern web development including{" "}
              <span className="light-grey">Bootstrap</span> and
              <span className="light-grey"> React-Router</span> to present users
              with a reactive, single-page web application. It is hosted with
              AWS' classic{" "}
              <span className="light-grey">Simple Storage Service (S3)</span>.
            </p>
            <h3>Back-end: Lambda, Node.js, API Gateway</h3>
            <p>
              At its core, the estimator runs on a series of{" "}
              <span className="light-grey">Lambda</span> functions written in{" "}
              <span className="light-grey">Node.js</span>.{" "}
              <span className="light-grey">AWS Lambda</span> lets customers run
              code while abstracting server provisioning and management away;
              this paradigm is known as Functions As A Service (Faas), and is a
              way of achieving a serverless architecture. This modern
              architecture is an extremely time and cost-effective way of
              operating back-end systems. These back-end functions are
              responsible for all the database operations.
            </p>
            <p>
              These Lambda functions are exposed to the front-end as a REST API
              using <span className="light-grey">AWS API Gateway</span>.
            </p>
            <h3>Data & User Storage: DynamoDB, Cognito</h3>
            <p>
              All user estimates are stored in AWS' traditional NoSQL database
              service, <span className="light-grey">DynamoDB</span>. A
              non-relational data model provided us with the flexibility to
              quickly iterate and test a rapidly evolving design.
            </p>
            <p>
              User registration and authentication is handled securely using{" "}
              <span className="light-grey">AWS Cognito</span>.
            </p>
            <h3>
              Deployment: Serverless Framework, CloudFormation & CloudFront
            </h3>
            <p>
              The <span className="light-grey">Serverless Framework</span> was a
              great accelerator that allowed us to build the above architecture,
              automatically provisioning the resources described in the
              architecture. The final architecture is contained in a{" "}
              <span className="light-grey">CloudFormation</span> template which
              allows us to effortlessly scale and redeploy it as required (known
              as Infrastructure As Code, or IaC).
            </p>
            <p>
              Finally, to ensure users to access the estimator using secure
              HTTPS and to speed up connection times globally, the front-end
              application is deployed to endpoints using{" "}
              <span className="light-grey">CloudFront</span>.
            </p>
          </Row>
          <Row className="centered-container">
            {this.renderDemoButton()}
            <HashLink to="/#pricing">
              <Button>PRICING</Button>
            </HashLink>
          </Row>
          <EstimatorFooter isAuthenticated={this.props.isAuthenticated} />
        </Col>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Blog.js